import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";

// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyA2aCtVfA3R5e8ninX7EtEcND_YJ2XmhAA",
  authDomain: "mss-driving.firebaseapp.com",
  projectId: "mss-driving",
  storageBucket: "mss-driving.firebasestorage.app",
  messagingSenderId: "803442629445",
  appId: "1:803442629445:web:4a551502b93b07c3dcbc2c",
  measurementId: "G-383Z593RLX"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
const analytics = getAnalytics(app);
